/**
 * @file 所有挂载到 Vue.prototype上的公共函数
*/

import * as tools from '@/utils/tools.js';


export default {
	nextTickFn(that) {
		return new Promise(resFn => {
			that.$nextTick(() => {
				resFn();
			})
		})
	},
    // 判断数据是否正常
	checkDataSuccessfulFn(result) {
        return !tools.objectGet(result, 'disableData');
	},
    // 判断网络请求是否正常
	checkApiSuccessfulFn(result) {
        const isSuccess = tools.objectGet(result, 'code') == 200;
        if(!isSuccess){
            if(tools.checkTypeFn(result) == 'Object'){
                result.disableData = true;
            }
            const msg = tools.objectGetString(result,'msg')
            if(msg){
                this.$message.error(msg);
            }
        }
        return isSuccess;
	},


	setDatasFn(that, data) {
		Object.keys(data).forEach(key => {
			that[key] = data[key];
		});
	},
	// 停止3秒钟
	sleepFn(time = 3) {
		console.log(`sleepFn 阻止程序${time}秒`);
		return new Promise((resFn) => {
			setTimeout(() => {
				resFn(`sleepFn 阻塞完毕${time}秒`);
			}, time * 1000);
		});
	},


    // 返回保留两位小数的字符串类型数字
	transDoubleNumStr(number) {
		return tools.toDoubleNumFn(tools.transNumFn(number))
	},

};



// WEBPACK FOOTER //
// ./src/utils/mixinMethods.js